var map = {
	"./autosicura.png": 4969,
	"./autosicura_logo.png": 807,
	"./avatar_agente.png": 2977,
	"./ballsystem_logo.png": 9081,
	"./car.png": 7913,
	"./carclinic.png": 5857,
	"./carclinic_logo.jpg": 4015,
	"./carclinic_logo.png": 8063,
	"./carglass_logo.png": 2347,
	"./carrozzeria_axa.png": 102,
	"./carsafe_logo.svg": 4600,
	"./cerca_officine.svg": 2407,
	"./default_logo.png": 7320,
	"./dottorgrandine_logo.jpg": 5665,
	"./eurograndine_logo.png": 7200,
	"./glassdrive_logo.jpg": 8121,
	"./hail_guard_logo.png": 557,
	"./house_blue.svg": 2174,
	"./icon/agente_blue.png": 6614,
	"./icon/agenzia_filiali_placeholder.png": 3243,
	"./icon/agenzia_filiali_placeholder_grey.png": 3201,
	"./icon/agenzia_filiali_placeholder_grey_padding.png": 6507,
	"./icon/arrow_up_down_white.png": 8351,
	"./icon/car_map_blue.png": 8561,
	"./icon/car_map_white.png": 5914,
	"./icon/carrozzerie_blue.png": 2366,
	"./icon/cerca_grey.png": 4513,
	"./icon/cerca_white.png": 5793,
	"./icon/chevron_down_white.png": 8727,
	"./icon/close_blue.png": 6182,
	"./icon/close_grey.png": 4543,
	"./icon/close_white.png": 9055,
	"./icon/compass_blue.png": 8734,
	"./icon/cristalli_blue.png": 4571,
	"./icon/cristalli_toolkit.png": 6709,
	"./icon/facebook_blue.png": 2878,
	"./icon/fax_blue.png": 7425,
	"./icon/filtro_blue.png": 6924,
	"./icon/geolocator_black.png": 7066,
	"./icon/geolocator_grey.png": 4274,
	"./icon/geolocator_white.png": 3228,
	"./icon/grandine_toolkit.png": 5630,
	"./icon/indicazioni_blue.png": 4905,
	"./icon/info_white.png": 7251,
	"./icon/lista_blue.png": 1705,
	"./icon/mail_blue.png": 2221,
	"./icon/mappa_blue.png": 6375,
	"./icon/minimize_white.png": 835,
	"./icon/orari_blue.png": 6819,
	"./icon/right_arrow_black.png": 421,
	"./icon/salute_vita_blue.png": 3829,
	"./icon/salute_white.png": 3615,
	"./icon/sito_blue.png": 9491,
	"./icon/street_view_blue.png": 3147,
	"./icon/subagenzia_filiali_placeholder.png": 8521,
	"./icon/suggeriti_blue.png": 3581,
	"./icon/suggeriti_white.png": 4766,
	"./icon/telefono_blue.png": 1342,
	"./icon/train_blue.png": 1780,
	"./icon/train_white.png": 3281,
	"./icon/walk_blue.png": 235,
	"./icon/walk_white.png": 8008,
	"./inova_logo.png": 380,
	"./landing_bg.jpg": 442,
	"./lever_touch_logo.png": 2433,
	"./loading.gif": 4148,
	"./maestridellagrandine_logo.png": 4590,
	"./maestridellagrandine_logo_OLD.jpg": 2376,
	"./man_black.svg": 9087,
	"./medical_black.svg": 6398,
	"./metafora_logo.png": 6210,
	"./mps_logo.png": 803,
	"./nonsolograndine_logo.png": 8101,
	"./orange/icon/agente.png": 998,
	"./orange/icon/car_map.png": 7669,
	"./orange/icon/carrozzerie.png": 9060,
	"./orange/icon/close.png": 9968,
	"./orange/icon/compass.png": 872,
	"./orange/icon/cristalli.png": 6531,
	"./orange/icon/facebook.png": 3214,
	"./orange/icon/fax.png": 7129,
	"./orange/icon/filtro.png": 3580,
	"./orange/icon/indicazioni.png": 2929,
	"./orange/icon/lista.png": 7577,
	"./orange/icon/mail.png": 3079,
	"./orange/icon/mappa.png": 5459,
	"./orange/icon/orari.png": 9683,
	"./orange/icon/salute_vita.png": 5121,
	"./orange/icon/sito.png": 2505,
	"./orange/icon/street_view.png": 623,
	"./orange/icon/suggeriti.png": 1441,
	"./orange/icon/telefono.png": 4398,
	"./orange/icon/train.png": 5626,
	"./orange/icon/walk.png": 5169,
	"./orange/services/auto.png": 7602,
	"./orange/services/carroattrezzi.png": 2735,
	"./orange/services/check_in.png": 5421,
	"./orange/services/chiavi.png": 4783,
	"./orange/services/gommista.png": 9246,
	"./orange/services/interventi_elettronica.png": 2548,
	"./orange/services/interventi_smart.png": 1593,
	"./orange/services/lavaggio.png": 4847,
	"./orange/services/meccanico.png": 351,
	"./orange/services/pickup_and_delivery.png": 7730,
	"./orange/services/revisioni.png": 6475,
	"./orange/services/ricarica_condizionatori.png": 8710,
	"./orange/services/riparazioni_spot.png": 7130,
	"./orange/services/riparazioni_veicoli_particolari.png": 8682,
	"./pin/pin_agenzie.png": 9636,
	"./pin/pin_agenzie_disable.png": 1025,
	"./pin/pin_agenzie_highlighted.png": 3442,
	"./pin/pin_autosicura.png": 5673,
	"./pin/pin_autosicura_highlighted.png": 8459,
	"./pin/pin_ballsystem.png": 5311,
	"./pin/pin_ballsystem_highlighted.png": 7717,
	"./pin/pin_blue.png": 3567,
	"./pin/pin_blue_highlighted.png": 9925,
	"./pin/pin_brown.png": 9575,
	"./pin/pin_brown_highlighted.png": 829,
	"./pin/pin_carclinic.png": 8577,
	"./pin/pin_carclinic_highlighted.png": 4227,
	"./pin/pin_carglass.png": 6109,
	"./pin/pin_carglass_highlighted.png": 3607,
	"./pin/pin_convenzionate_axa.png": 779,
	"./pin/pin_convenzionate_axa_highlighted.png": 1481,
	"./pin/pin_dottor_grandine.png": 4312,
	"./pin/pin_dottor_grandine_highlighted.png": 7982,
	"./pin/pin_eurograndine.png": 1732,
	"./pin/pin_eurograndine_highlighted.png": 7586,
	"./pin/pin_glassdrive.png": 4247,
	"./pin/pin_glassdrive_highlighted.png": 1373,
	"./pin/pin_hailguard.png": 526,
	"./pin/pin_hailguard_highlighted.png": 1344,
	"./pin/pin_inova.png": 6368,
	"./pin/pin_inova_highlighted.png": 2326,
	"./pin/pin_levertouch.png": 2370,
	"./pin/pin_levertouch_highlighted.png": 7644,
	"./pin/pin_locator_blue.svg": 4456,
	"./pin/pin_maestri.png": 2746,
	"./pin/pin_maestri_highlighted.png": 1316,
	"./pin/pin_mps.png": 6533,
	"./pin/pin_mps_highlighted.png": 8719,
	"./pin/pin_nonsolograndine.png": 6491,
	"./pin/pin_nonsolograndine_highlighted.png": 9510,
	"./pin/pin_odontoiatria.png": 4236,
	"./pin/pin_odontoiatria_highlighted.png": 6618,
	"./pin/pin_odontoiatria_highlighted_old.png": 712,
	"./pin/pin_odontoiatria_old.png": 7018,
	"./pin/pin_protezione_salute.png": 4379,
	"./pin/pin_protezione_salute_highlighted.png": 2249,
	"./pin/pin_red.png": 8366,
	"./pin/pin_red_highlighted.png": 64,
	"./pin/pin_riparte.png": 322,
	"./pin/pin_riparte_highlighted.png": 2412,
	"./pin/pin_route_end.png": 8058,
	"./pin/pin_route_start.png": 8601,
	"./pin/pin_semplicemente_vita.png": 4223,
	"./pin/pin_semplicemente_vita_highlighted.png": 6581,
	"./pin/pin_sos_grandine.png": 7811,
	"./pin/pin_sos_grandine_highlighted.png": 5505,
	"./pin/pin_specialistici_convenzionati.png": 1711,
	"./pin/pin_specialistici_convenzionati_highlighted.png": 117,
	"./pin/pin_specialistici_convenzionati_highlighted_old.png": 2064,
	"./pin/pin_specialistici_convenzionati_old.png": 197,
	"./pin/pin_stormsolution.png": 901,
	"./pin/pin_stormsolution_highlighted.png": 4575,
	"./pin/pin_subagenzie.png": 8966,
	"./pin/pin_subagenzie_disable.png": 7263,
	"./pin/pin_subagenzie_highlighted.png": 808,
	"./pin/pin_upgrandine.png": 4872,
	"./pin/pin_upgrandine_highlighted.png": 8846,
	"./pin/pin_vetrocar.png": 7213,
	"./pin/pin_vetrocar_highlighted.png": 4599,
	"./pin/pin_yellow.png": 1643,
	"./pin/pin_yellow_highlighted.png": 4345,
	"./riparte.png": 1202,
	"./services/auto_blue.png": 8686,
	"./services/carroattrezzi_blue.png": 7731,
	"./services/check_in_blue.png": 8303,
	"./services/chiavi_blue.png": 1609,
	"./services/foglia.png": 9842,
	"./services/gommista_blue.png": 9718,
	"./services/interventi_elettronica_blue.png": 7636,
	"./services/interventi_smart_blue.png": 895,
	"./services/lavaggio_blue.png": 6129,
	"./services/logo_asseverato_blu_bold.png": 3649,
	"./services/logo_bmw_mini.png": 6018,
	"./services/logo_tesla_approved.png": 9431,
	"./services/meccanico_blue.png": 3487,
	"./services/pickup_and_delivery_blue.png": 9788,
	"./services/revisioni_blue.png": 3059,
	"./services/ricarica_condizionatori_blue.png": 1868,
	"./services/riparazioni_spot_blue.png": 9774,
	"./services/riparazioni_veicoli_particolari_blue.png": 4348,
	"./services/soccorso_stradale_axa.svg": 343,
	"./services/soccorso_stradale_axa_OLD.png": 8019,
	"./sosgrandine_logo.jpg": 4450,
	"./stormsolution_logo.png": 4979,
	"./up_grandine_logo.png": 6123,
	"./vetrocar_logo.jpg": 7107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;